import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as apicall from "../../components/Apicall";

const ProvidedServices = () => {
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const industry = location.state;

  const options = [
    "I visit my clients as a mobile operator",
    "Clients come to me at a physical location",
    "I provide virtual service online",
  ];

  useEffect(() => {
    getUserProfile();
  }, []);

  const getUserProfile = async () => {
    try {
      const res = await apicall.get("ezpMyProfile");
      if (res.success) {
        const user = res?.data[0];
        setUserId(user?.id);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const toggleOption = (opt) => {
    setSelected((prev) =>
      prev.includes(opt)
        ? prev.filter((i) => i !== opt)
        : [...prev, opt]
    );
  };

const handleSubmit = async () => {

  if (selected.length === 0) {
    return;
  }

  if (!industry) {
    return;
  }

  if (!userId) {
    return;
  }

  try {
    setLoading(true);

    const data = {
      user_id: userId,
      industry: industry?.id,
      service_locations: selected,
    };
    const res = await apicall.post(data,"saveIndustry");

    console.log("saveIndustry response:", res);
    let isStepUpDone = await setUpIsDone();

    if (!isStepUpDone) {
      navigate("/setup");
    } else {
      navigate("/dashboard");
    }

  } catch (err) {
    console.log("ERROR:", err);
  } finally {
    setLoading(false);
  }
};

  const setUpIsDone = async () => {
    try {
      let [
        ezpMyProfile,
        services_api,
        service_type_api,
        get_ezp_service_providers,
        get_ezp_booking,
      ] = await Promise.all([
        apicall.get(`ezpMyProfile`),
        apicall.get(`get_ezp_service`),
        apicall.get(`get_ezp_service_types`),
        apicall.get(`get_ezp_service_providers?skill=PROFESSIONAL`),
        apicall.get(`get_ezp_booking?page=1&limit=1`),
      ]);

      // Persist the freshly-saved industry (and rest of the profile) immediately —
      // otherwise localStorage.userDetails stays stale until something else (e.g.
      // Navbar remounting on a refresh) happens to refetch it, so every
      // industry-gated screen (Setup tabs, appointment status dropdown, etc.)
      // renders with the wrong/default industry right after onboarding.
      if (ezpMyProfile?.data?.[0]) {
        localStorage.setItem("userDetails", JSON.stringify(ezpMyProfile.data[0]));
      }

      // Clinic vendors (industry 1) never create sub-categories/service types —
      // that field is hidden for them in Admin Setup — so requiring one would
      // make setup completion permanently impossible for this industry.
      const isClinicService = Number(ezpMyProfile?.data?.[0]?.industry) === 1;
      let ans = {
        profile: ezpMyProfile?.data?.[0]?.state_name ? true : false,
        service: services_api?.data?.length > 0,
        type: isClinicService ? true : service_type_api?.data?.length > 0,
        crew: get_ezp_service_providers?.data?.length > 0,
        order: get_ezp_booking?.data?.length > 0,
      };

      return Object.values(ans).every(Boolean);

    } catch (e) {
      console.log("setUpIsDone error", e);
      return false;
    }
  };
const handleBack = () => {
  navigate(-1);
};
  return (
    <div className="onboarding-wrapper">
      <div className="onboarding-card">
        <h5 className="title">
          Where do you provide your services?
        </h5>

        <p className="subtitle">
          This will help us to setup your requirement much better.
        </p>

        <div className="options-container">
          {options.map((opt, i) => {
            const isSelected = selected.includes(opt);

            return (
              <div
                key={i}
                onClick={() => toggleOption(opt)}
                className={`option-box ${isSelected ? "active" : ""}`}
              >
                <span>{opt}</span>

                <div className={`checkbox ${isSelected ? "checked" : ""}`}>
                  {isSelected && "✓"}
                </div>
              </div>
            );
          })}
        </div>
<div className="d-flex gap-2 mt-3">
  <button
 className="btn btn-danger" 
     onClick={handleBack}
  >
    Back
  </button>

  <button
 className="btn btn-danger" 
     onClick={handleSubmit}
    disabled={loading}
  >
    {loading ? "Saving..." : "Submit"}
  </button>
</div>
      </div>
    </div>
  );
};

export default ProvidedServices;